import { render } from "./Index.vue?vue&type=template&id=5e70e67a&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=5e70e67a&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e70e67a"]])

export default __exports__